export const PATH_NAME = {
  ROOT: '/',
  UPDATE_PASSWORD: '/update-password',
  ERROR_404: '/404',
  ERROR_403: '/403',
  DASHBOARD: '/dashboard',
  VERIFY: '/email/mark-complaint',
  PLAY_BACKGROUND: '/playbackground',
  LOGIN: '/login',

  // MASTER //
  MASTER: '/master',

  // MASTER/SUB-ROUTES //

  // LISTING
  COUNTRY_MASTER_LIST: '/master/country-master/list',
  STATE_MASTER_LIST: '/master/state-master/list',
  DISTRICT_MASTER_LIST: '/master/district-master/list',
  SUB_DISTRICT_MASTER_LIST: '/master/sub-district-master/list',
  USER_MASTER_LIST: '/master/user-master/list',
  USER_PENDING_SC_LIST: '/master/user-state-pending/list',
  USER_PENDING_ADMIN_LIST: '/master/user-admin-pending/list',
  CATEGORY_MASTER_LIST: '/master/category-master/list',
  SUB_CATEGORY_MASTER_LIST: '/master/sub-category-master/list',
  DEPARTMENT_MASTER_LIST: '/master/department-master/list',
  DESIGNATION_MASTER_LIST: '/master/designation-master/list',

  // ADD
  COUNTRY_MASTER_ADD: '/master/country-master/list',
  STATE_MASTER_ADD: '/master/state-master/list',
  DISTRICT_MASTER_ADD: '/master/district-master/list',
  SUB_DISTRICT_MASTER_ADD: '/master/sub-district-master/list',
  USER_MASTER_ADD: '/master/user-master/add',
  CATEGORY_MASTER_ADD: '/master/category-master/list',
  SUB_CATEGORY_MASTER_ADD: '/master/sub-category-master/list',
  DEPARTMENT_MASTER_ADD: '/master/department-master/list',
  DESIGNATION_MASTER_ADD: '/master/designation-master/list',

  USER_MASTER_EDIT: '/master/user-master/edit',

  // COMPLAINT ASSIGNMENT //
  COMPLAINT_ASSIGNMENT: '/complaint-assignment',

  // COMPLAINT-ASSIGNMENT/SUB-ROUTES //
  // LISTING
  ASSIGNMENT_MASTER_LIST: '/complaint-assignment/assignment-master/list',

  // ADD
  ASSIGNMENT_MASTER_ADD: '/complaint-assignment/assignment-master/add',

  // Update
  ASSIGNMENT_MASTER_EDIT: '/complaint-assignment/assignment-master/edit',

  // --Individual sections--

  // LISTING
  COMPLAINT_VIEW_LIST: '/complaint-view/list',
  POSITIVE_FEEDBACK_LIST: '/positive-feedback/list',
  POSITIVE_FEEDBACK_View: '/positive-feedback/view',
  LATEST_UPDATE_LIST: '/latest-update/list',
  LATEST_UPDATE_EDIT: '/latest-update/edit',
  GUIDELINES_AND_CIRCULARS_LIST: '/guidelines/list',
  GUIDELINES_AND_CIRCULARS_EDIT: '/guidelines/edit',
  EVENT_LIST: '/event/list',
  INFORMATION_LIST: '/information/list',

  INFORMATION_EDIT: '/information/edit',

  RESOURCES_LIST: '/resources/list',
  RESOURCE_ADD: '/resources/add',
  RESOURCE_UPDATE: '/resources/edit',

  HELPLINES_LIST: '/helplines/list',
  HELPLINE_ADD: '/helplines/add',
  HELPLINE_UPDATE: '/helplines/edit',

  NOTIFICATION_SEND: '/notifications/send',

  OPPORTUNITY_LIST: '/opportunity/list',
  OPPORTUNITY_ADD: '/opportunity/add',
  OPPORTUNITY_EDIT: '/opportunity/edit',
  USER_OPPORTUNITIES_LIST: '/user-opportunities/list',

  SCHEMES_LIST: '/schemes/list',
  SCHEMES_ADD: '/schemes/add',
  SCHEMES_EDIT: '/schemes/edit',

  // ADD
  COMPLAINT_VIEW_EDIT: '/complaint-view/edit',
  POSITIVE_FEEDBACK_ADD: '/positive-feedback/add',
  LATEST_UPDATE_ADD: '/latest-update/add',
  GUIDELINES_AND_CIRCULARS_ADD: '/guidelines/add',
  EVENT_ADD: '/event/add',
  EVENT_UPDATE: '/event/edit',
  INFORMATION_ADD: '/information/add',
  PRODUCT_ADD: '/complaint-view/add',
  PRODUCT_LIST: '/complaint-view/list',

  USERS: '/users',
  KANBAN: '/kanban',

  COMPLAINT_REASSIGNMENT_LIST: '/complaint-reassignment/list',

  FEEDBACK_FORM: '/feedback',
};
